// NOTE: CUSTOM EXTENSION WHICH IS ALSO FROM CHATGPT
import {Node, mergeAttributes} from '@tiptap/core'

export const FileAttachment = Node.create({
  name: 'fileAttachment',

  group: 'block',
  inline: false,
  atom: true,

  addAttributes() {
    return {
      href: {default: null},
      filename: {default: null},
    }
  },

  parseHTML() {
    return [{tag: 'a[data-type="file-attachment"]'}]
  },

  renderHTML({HTMLAttributes}) {
    return [
      'a',
      mergeAttributes(HTMLAttributes, {
        'data-type': 'file-attachment',
        href: HTMLAttributes.href,
        download: HTMLAttributes.filename,
        target: '_blank',
      }),
      `📎 ${HTMLAttributes.filename}`,
    ]
  },

  addCommands() {
    return {
      insertFileAttachment:
        (options: {href: string; filename: string}) =>
        ({chain}) => {
          const {href, filename} = options
          return chain()
            .insertContent(
              `<a href="${href}" classname="w-60" download="${filename}" data-type="file-attachment">📎 ${filename}</a>`
            )
            .run() // ✅ <--- this is necessary
        },
    }
  },
})
